import { Link } from "react-router-dom";
import { Headphones, ArrowRight } from "lucide-react";

export default function TalkLibraryHubCard() {
  return (
    <Link to="/talk-library/t1g-sepl" data-testid="hub-talks-card"
          className="group block rounded-2xl bg-white p-5 sm:p-6 ring-1 ring-[#C9A961]/40 hover:ring-[#C9A961] transition-shadow shadow-sm">
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-xl bg-[#0A1F44] text-[#C9A961] flex items-center justify-center shrink-0">
          <Headphones className="w-6 h-6" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[10px] uppercase tracking-[0.24em] text-[#C9A961] font-semibold">Listening</div>
          <div className="font-serif text-xl sm:text-2xl text-[#0A1F44] mt-0.5">Podcast Library</div>
          <p className="text-slate-600 text-sm mt-1">Browse the T1G / SEPL Talk List by topic and search the full SEPL Master List.</p>
        </div>
        <ArrowRight className="w-5 h-5 text-[#C9A961] mt-1 transition-transform group-hover:translate-x-1" />
      </div>
    </Link>
  );
}
